import { Builder } from '@builder.io/react';

import VideoGallery from './index';

Builder.registerComponent(VideoGallery, {
  name: 'VideoGallery',
  inputs: [
    {
      name: 'videos',
      type: 'list',
      defaultValue: [
        {
          src: '',
          cover: '',
          paragraph: ''
        }
      ],
      subFields: [
        {
          name: 'src',
          type: 'string'
        },
        { name: 'cover', type: 'file', allowedFileTypes: ['jpg', 'png', 'jpeg'] },
        {
          name: 'paragraph',
          type: 'longText'
        },
        { name: 'body', type: 'longText' }
      ]
    },
    { name: 'showParagraphUnderVideo', type: 'boolean', defaultValue: true }
  ]
});
